import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const SettingsSkeleton: React.FC = () => {
  return (
    <section id="settings" className="content-section">
      <div className="flex justify-between items-center mb-6 header-border pb-4">
        <h2 className="text-xl font-semibold text-white">settings</h2>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="paint-card p-4">
          <div className="border-b-2 border-gray-600 pb-2 mb-4">
            <SkeletonLoader width="w-32" height="h-6" />
          </div>
          <div className="space-y-4">
            <div>
              <SkeletonLoader width="w-48" height="h-4" className="mb-2" />
              <div className="flex gap-2">
                <SkeletonLoader width="flex-1" height="h-10" />
                <SkeletonLoader width="w-20" height="h-10" />
              </div>
            </div>
            <div>
              <SkeletonLoader width="w-16" height="h-4" className="mb-2" />
              <SkeletonLoader width="w-full" height="h-12" />
            </div>
          </div>
        </div>
        
        <div className="paint-card p-4">
          <div className="border-b-2 border-gray-600 pb-2 mb-4">
            <SkeletonLoader width="w-24" height="h-6" />
          </div>
          <div className="space-y-4">
            <div>
              <SkeletonLoader width="w-32" height="h-4" className="mb-2" />
              <SkeletonLoader width="w-20" height="h-10" />
            </div>
            <div className="flex items-center justify-between">
              <SkeletonLoader width="w-36" height="h-4" />
              <SkeletonLoader width="w-12" height="h-6" className="rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SettingsSkeleton;